module.exports = __webpack_public_path__ + "media/images/shopify_faq_1-333c5cd2e2d8b72fd4d1998d2307cda4.png";